import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { TaskFindingStatus } from "../../../shared/types";

export function useFindingDismiss(runId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { findingId: string; status?: TaskFindingStatus }) =>
      api.patch<{ data: { id: string; status: TaskFindingStatus } }>(
        `/api/task-findings/${encodeURIComponent(String(data.findingId))}/dismiss`,
        data.status ? { status: data.status } : {},
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["task-run-findings", runId] });
    },
  });
}
